import { createFileRoute } from "@tanstack/react-router";
import { ShoppingPage } from "@/features/shopping/shopping-page";

export const Route = createFileRoute("/app/w/$weddingId/shopping")({ component: ShoppingPage });
